import axios from 'axios';
import { getApiBaseUrl } from '../utils/httpConfig';

export { getApiBaseUrl };

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
      }

      return Promise.reject({
        status,
        message: data.message || data.title || 'An error occurred',
        errors: data.errors || {},
      });
    } else if (error.request) {
      return Promise.reject({
        status: 0,
        message: 'Backend server is unavailable. Please try again later.',
      });
    } else {
      return Promise.reject({
        status: -1,
        message: error.message || 'An unexpected error occurred',
      });
    }
  }
);

export default api;
